import s from './SelectedPopup.module.scss';
import { getAppEnvironment } from '@/shared/lib/runtimeEnvironment';
import { DeleteAccountButton } from '@/features/DeleteAccount';
import { GeneralSelectedI } from '@/shared/model/types/generalSelected';
import { useScreenDetector } from '@/shared/lib/hooks/useScreenDetector';
import { DraggableButton } from '@/features/DraggableButton';
import { Portal } from '@/shared/ui/Portal/Portal';
import { useRef } from 'react';

interface SelectedPopupProps extends GeneralSelectedI {
  resetSelectedRows?: () => void;
  mode?: 'account' | 'club';
}

export const SelectedPopup = (props: SelectedPopupProps) => {
  const { arrayOfName, arrayOfId, resetSelectedRows, mode = 'account' } = props;
  const popupRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useScreenDetector();

  return (
    <Portal>
      <div className={s.SelectedPopup} ref={popupRef}>
        {isMobile ? (
          <div className={s.header}>
            <span className={s.info}>Выбрано записей: {arrayOfId.length}</span>
            <DraggableButton popupRef={popupRef} />
          </div>
        ) : (
          <span className={s.info}>Выбрано записей: {arrayOfId.length}</span>
        )}

        <div className={s.actions}>
          <DeleteAccountButton
            arrayOfName={arrayOfName}
            arrayOfId={arrayOfId}
            accountStatuses={props.accountStatuses}
            resetSelectedRows={resetSelectedRows}
            mode={mode}
            deletionType="lifecycle"
          />
          {mode === 'account' && getAppEnvironment() === 'dev' && (
            <DeleteAccountButton
              arrayOfName={arrayOfName}
              arrayOfId={arrayOfId}
              accountStatuses={props.accountStatuses}
              resetSelectedRows={resetSelectedRows}
              mode={mode}
              deletionType="hard"
            />
          )}
        </div>
      </div>
    </Portal>
  );
};
